import { cn } from "../Invoice/invoiceUtils";


export const Input = ({
  label,
  value,
  onChange,
  error,
  disabled,
  rightIcon,
  placeholder,
  type = "text",
}) => {
  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    ( authUser?.role === 5 || authUser?.role === 6 );

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label
          className={cn(
            "text-sm font-medium",
            isRetailerMobile ? "text-black/90" : "text-slate-700"
          )}
        >
          {label}
        </label>
      )}

      {/* INPUT WRAPPER */}
      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className={cn(
            "w-full px-4 py-2.5 rounded-xl text-sm pr-10 outline-none transition-all duration-300 !text-left",
            
            // MOBILE GLASS STYLE
            isRetailerMobile
              ? disabled
                ? "glass-small-card bg-white/10 text-black/60 border border-white/20 cursor-not-allowed text-left placeholder-black/50"
                : "glass-small-card bg-white/10 backdrop-blur-xl border border-white/30 text-black placeholder-black/50 focus:ring-2 focus:ring-white/40 focus:bg-white/15"
              :
            // DESKTOP STYLE
              disabled
                ? "bg-slate-100 cursor-not-allowed border border-slate-200"
                : "bg-white border border-slate-300 focus:ring-2 focus:ring-blue-500",

            error &&
              (isRetailerMobile
                ? "border-red-400 focus:ring-red-400"
                : "border-red-500 focus:ring-red-500")
          )}
        />

        {/* RIGHT ICON */}
        {rightIcon && (
          <div
            className={cn(
              "absolute inset-y-0 right-3 flex items-center",
              isRetailerMobile ? "text-white/70" : "text-slate-500"
            )}
          >
            {rightIcon}
          </div>
        )}
      </div>

      {error && (
        <p
          className={cn(
            "text-xs",
            isRetailerMobile ? "text-red-300" : "text-red-500"
          )}
        >
          {error}
        </p>
      )}
    </div>
  );
};

// export const Input = ({
//   label,
//   value,
//   onChange,
//   error,
//   disabled,
//   rightIcon,        // ✅ NEW
//   placeholder,
//   type = "text",
// }) => (
//   <div className="flex flex-col gap-1">
//     {label && (
//       <label className="text-sm font-medium text-slate-700">
//         {label}
//       </label>
//     )}

//     {/* INPUT WRAPPER */}
//     <div className="relative">
//       <input
//         type={type}
//         value={value}
//         onChange={onChange}
//         disabled={disabled}
//         placeholder={placeholder}
//         className={`w-full px-3 py-2 border rounded-lg text-sm pr-10
//           ${disabled ? "bg-slate-100 cursor-not-allowed" : "bg-white"}
//           ${error ? "border-red-500 focus:ring-red-500" : "border-slate-300"}
//         `}
//       />

//       {/* RIGHT ICON */}
//       {rightIcon && (
//         <div className="absolute inset-y-0 right-2 flex items-center">
//           {rightIcon}
//         </div>
//       )}
//     </div>

//     {error && (
//       <p className="text-xs text-red-500">
//         {error}
//       </p>
//     )}
//   </div>
// );
